import { posthog } from "posthog-js";

type EventProps = {
  eventName: string;
  properties?: {
    button_label: string;
    action: string;
    section: string;
    flow: string;
    asset?: string;
    blockchain?: string;
    sell_asset?: string;
    sell_blockchain?: string;
    buy_asset?: string;
    buy_blockchain?: string;
    $current_url?: string;
  };
};

const trackPostHogEvent = (
  eventName: EventProps["eventName"],
  properties?: EventProps["properties"]
) => {
  posthog.capture(eventName, properties, {
    timestamp: new Date(),
  });
};

export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  posthog.identify(userId, properties);
};

export const setUserProperty = (property: string, value: any) => {
  posthog.setPersonProperties({ [property]: value });
};

export const resetUser = () => {
  posthog.reset();
};

export const trackButtonClick = (
  action: EventProps["eventName"],
  additionalProps?: EventProps["properties"]
) => {
  trackPostHogEvent(action, additionalProps);
};

export const trackPageView = () => trackPostHogEvent("$pageview");
